import { useState } from 'react'
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect'

const IS_SERVER = typeof window === 'undefined'

export function useMediaQuery(query, options = {}) {
	const { defaultValue = false, initializeWithValue = true } = options

	const getMatches = (query) => {
		if (IS_SERVER) {
			return defaultValue
		}
		return window.matchMedia(query).matches
	}

	const [matches, setMatches] = useState(() => {
		if (initializeWithValue) {
			return getMatches(query)
		}
		return defaultValue
	})

	function handleChange() {
		setMatches(getMatches(query))
	}

	useIsomorphicLayoutEffect(() => {
		const matchMedia = window.matchMedia(query)

		handleChange()

		if (matchMedia.addListener) {
			matchMedia.addListener(handleChange)
		} else {
			matchMedia.addEventListener('change', handleChange)
		}

		return () => {
			if (matchMedia.removeListener) {
				matchMedia.removeListener(handleChange)
			} else {
				matchMedia.removeEventListener('change', handleChange)
			}
		}
	}, [query])

	return matches
}
